import { c as _c } from "react/compiler-runtime";
import type { Option } from '@newfront-insurance/core-ui';
import { SelectInput } from '@newfront-insurance/core-ui';
import { useEffect, useState, type JSX } from 'react';
import * as React from 'react';
interface Props {
  value?: string;
  onChange: (stateName: string) => unknown;
  disabled?: boolean;
  name?: string;
  innerRef?: React.MutableRefObject<HTMLSelectElement>;
  placeholder?: string;
  testId?: string;
  countryCode?: string;
}
async function getCountryStateOptions(countryCode: string): Promise<Option[]> {
  /**
   * pass iso3 country code to 'country-code-lookup' to get it's iso2
   * then pass the iso2, to 'country-state-city', to get the states
   */
  const lookup = (await import('country-code-lookup')).default;
  const countries = await import('country-state-city');
  const iso2 = lookup.byIso(countryCode)?.iso2;
  if (!iso2) return [];
  const states = countries.State.getStatesOfCountry(iso2);
  const options: Option[] = states.map(({
    name,
    isoCode
  }) => ({
    label: name,
    value: isoCode
  }));
  return options;
}
export function CountryStateSelect(t0) {
  const $ = _c(23);
  const {
    countryCode: t1,
    name: elementName,
    onChange,
    value,
    innerRef,
    disabled,
    placeholder: t2,
    testId
  } = t0;
  const countryCode = t1 === undefined ? "USA" : t1;
  const placeholder = t2 === undefined ? "Select state" : t2;
  const [options, setOptions] = useState();
  let t3;
  if ($[0] !== countryCode || $[1] !== options || $[2] !== value) {
    t3 = value && countryCode === "USA" ? value : options?.find(option => option.label === value)?.value;
    $[0] = countryCode;
    $[1] = options;
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedId = t3;
  let t4;
  let t5;
  if ($[4] !== countryCode) {
    t4 = () => {
      getCountryStateOptions(countryCode).then(countries => setOptions(countries));
    };
    t5 = [countryCode];
    $[4] = countryCode;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== options) {
    t6 = options || [];
    $[7] = options;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== countryCode || $[10] !== onChange || $[11] !== options) {
    t7 = val => {
      if (countryCode === "USA") {
        onChange(val);
      } else {
        const selectedOption = (options || []).find(option_0 => option_0.value === val);
        onChange(selectedOption?.label || "");
      }
    };
    $[9] = countryCode;
    $[10] = onChange;
    $[11] = options;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !value;
  let t9;
  if ($[13] !== disabled || $[14] !== elementName || $[15] !== innerRef || $[16] !== placeholder || $[17] !== selectedId || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== testId) {
    t9 = <SelectInput name={elementName} options={t6} onChange={t7} showSelectAnOption={t8} placeholder={placeholder} value={selectedId} innerRef={innerRef} disabled={disabled} testId={testId} />;
    $[13] = disabled;
    $[14] = elementName;
    $[15] = innerRef;
    $[16] = placeholder;
    $[17] = selectedId;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = testId;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}